import { Alert, Button } from '30pay/components';
import { Modal, Popover, Skeleton, Tooltip } from 'antd';
import { LevelDetail, ReduxState } from 'interfaces';
import React, { useEffect, useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { FaSquareCheck } from 'react-icons/fa6';
import { Card, SiPayModal } from 'utilities/components';
import ProfileVerifyModal from './modal/verifyModal.index';
import { get } from 'scripts';
import { _hasRejectedUpgradeModalShown as hasRejectedUpgradeModalShown } from 'scripts/storage';
import { API } from 'data/30pay.api';
import ProfileProfessionalVerifyModal from './modal/professional/professionalVerify.index';
import { getProfile } from 'services';
interface OwnProps {
    className?: string;
    isPreview?: boolean;
}

type Props = OwnProps & ConnectedProps<typeof connector>;

interface RejectedUpgradeModalProps {
    open: boolean;
    reason?: string;
    onCancel: () => void;
    onVerify: () => void;
}

const RejectedUpgradeModal: React.FC<RejectedUpgradeModalProps> = ({ open, reason, onCancel, onVerify }) => {
    return (
        <SiPayModal
            isOpen={open}
            onClose={onCancel}
            footer={null}
            title={<span className="font-bold text-lg">درخواست احراز شما رد شد</span>}
        >
            <div className="flex flex-col gap-4 text-right">
                <p className="text-sm text-darkPurple-100">
                    مدرک احراز هویت شما رد شده است. می‌توانید پس از رفع مشکل، مجدداً درخواست احراز هویت ارسال کنید.
                </p>
                {reason && (
                    <div className="bg-negative-light/20 border border-negative-light rounded-xl px-3 py-2 text-sm text-negative-dark">
                        <span className="font-semibold ml-1">دلیل رد:</span>
                        <span>{reason}</span>
                    </div>
                )}
                <div className="mt-4 flex justify-end gap-3 w-full">
                    <Button className="w-full" type="primary" onClick={onVerify}>
                        احراز هویت مجدد
                    </Button>
                    <Button className="w-full" onClick={onCancel}>
                        انصراف
                    </Button>
                </div>
            </div>
        </SiPayModal>
    );
};

const ProfileVerify: React.FC<Props> = function (props) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isProfessinalModalOpen, setIsProfessionalModalOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [levelDetail, setLevelDetail] = useState<LevelDetail>();
    const level = props.user?.level.uniqueName;
    const [isRejectedModalOpen, setIsRejectedModalOpen] = useState(false);
    function getMineLevel() {
        setLoading(true);
        get<LevelDetail>(API.level.mine)
            .then((e) => setLevelDetail(e.value.value))
            .catch((err) => console.log(err))
            .finally(() => setLoading(false));
    }
    useEffect(() => {
        getMineLevel();
    }, []);
    useEffect(() => {
        if (!props.isPreview) return;
        if (!levelDetail || levelDetail.upgradeRequestState !== 2 || !levelDetail.rejectUpgradeMessage) return;
        if (!levelDetail.uniqueName || levelDetail.uniqueName.id > 2) return; // in bayad >2 bashe havaset bashe ja nzri

        if (typeof window === 'undefined' || typeof window.localStorage === 'undefined') {
            setIsRejectedModalOpen(true);
            return;
        }

        try {
            const hasSeen = hasRejectedUpgradeModalShown.get();
            if (!hasSeen) {
                setIsRejectedModalOpen(true);
                hasRejectedUpgradeModalShown.set(true);
            }
        } catch (err) {
            setIsRejectedModalOpen(true);
        }
    }, [levelDetail, props.isPreview]);
    return (
        <>
            {props.isPreview && (
                <RejectedUpgradeModal
                    open={isRejectedModalOpen}
                    reason={levelDetail?.rejectUpgradeMessage}
                    onCancel={() => setIsRejectedModalOpen(false)}
                    onVerify={() => {
                        setIsRejectedModalOpen(false);
                        if (level?.id === 1) {
                            setIsModalOpen(true);
                        } else if (level?.id === 2) {
                            setIsProfessionalModalOpen(true);
                        }
                    }}
                />
            )}
            {!props.isPreview &&
                levelDetail?.rejectUpgradeMessage &&
                levelDetail?.upgradeRequestState === 2 &&
                props.user?.level.uniqueName.id &&
                props.user?.level.uniqueName.id <= 2 && (
                    <Alert
                        variant="error"
                        message={`درخواست احراز شما رد شده است، لطفا مجددا تلاش فرمایید. دلیل: ${levelDetail.rejectUpgradeMessage}`}
                    />
                )}
            <Card className={`mt-4 ${props.className ? props.className : ''}`}>
                <ProfileVerifyModal
                    isOpen={isModalOpen}
                    onClose={(needReFetch) => {
                        setIsModalOpen(false);
                        if (needReFetch) {
                            getProfile(props.dispatch);
                            getMineLevel();
                        }
                    }}
                />
                <ProfileProfessionalVerifyModal
                    isOpen={isProfessinalModalOpen}
                    onClose={(needReFetch) => {
                        setIsProfessionalModalOpen(false);
                        if (needReFetch) getMineLevel();
                    }}
                />

                <div className="flex items-center gap-4">
                    <h4 className="font-bold text-xl max-lg:text-base">
                        {props.user?.fullName ?? props.user?.phoneNumber}
                    </h4>
                    {!loading ? (
                        level &&
                        //Level 0
                        (level.id === 1 ? (
                            <div
                                className={`py-1 px-3 font-bold text-xs  rounded-[30px] border-[3px] text-white bg-warning-default border-warning-light`}
                            >
                                نیاز به احراز
                            </div>
                        ) : //Level 1
                        level.id === 2 ? (
                            <>
                                <div
                                    className={`py-1 px-3 font-bold text-xs  rounded-[30px] border-[3px] text-white ${
                                        levelDetail?.upgradeRequestState === 0
                                            ? 'bg-secondary-100 border-secondary-20'
                                            : levelDetail?.upgradeRequestState === 2
                                              ? 'bg-negative-dark border-negative-light'
                                              : 'bg-warning-default border-warning-light'
                                    }`}
                                >
                                    {levelDetail?.upgradeRequestState === 0
                                        ? 'در حال بررسی اطلاعات'
                                        : levelDetail?.upgradeRequestState === 2
                                          ? 'رد شده'
                                          : 'نیاز به احراز'}
                                </div>
                                {levelDetail?.upgradeRequestState === 2 && levelDetail?.rejectUpgradeMessage && (
                                    <Tooltip title={levelDetail.rejectUpgradeMessage}>
                                        <span className="inline-block max-w-[200px] truncate text-negative-dark text-xs font-medium">
                                            {levelDetail.rejectUpgradeMessage}
                                        </span>
                                    </Tooltip>
                                )}
                            </>
                        ) : (
                            //Level 2
                            <div
                                className={`py-1 px-3 font-bold text-xs  rounded-[30px] border-[3px] text-white bg-positive-dark border-positive-light`}
                            >
                                تایید شده
                            </div>
                        ))
                    ) : (
                        <Skeleton.Node active style={{ width: 80, height: 24 }} />
                    )}
                </div>
                <div className="w-full flex items-center mt-2">
                    <Popover
                        trigger="hover"
                        content={
                            <div className="flex flex-col gap-2">
                                {['واریز رمز ارز', 'واریز تومانی', 'برداشت تومانی'].map((item, index) => (
                                    <div key={index} className="flex gap-2">
                                        <FaSquareCheck size={16} className="text-positive-dark" />
                                        <h6 className="font-medium text-xs text-darkPurple-100">{item}</h6>
                                    </div>
                                ))}
                            </div>
                        }
                    >
                        <h6 className="font-bold text-base text-primary-100 clickable max-lg:text-xs">
                            مزایای احراز هویت حرفه‌ای
                        </h6>
                    </Popover>
                    <div className="flex-1" />
                    <Tooltip
                        title={
                            loading
                                ? 'لطفا صبر کنید' //Loading
                                : level?.id === 1
                                  ? 'برای احراز هویت کلیک کنید' //Level 0
                                  : level?.id === 2 //Level 1
                                    ? levelDetail?.upgradeRequestState === 0
                                        ? 'لطفا برای بررسی اطلاعات منتظر بمانید'
                                        : 'برای احراز هویت کلیک کنید'
                                    : 'شما به حداکثر سطح رسیده‌اید' // Level 2
                        }
                    >
                        <Button
                            disabled={
                                loading ||
                                !level ||
                                (level.id === 2 && levelDetail?.upgradeRequestState === 0) ||
                                level.id > 2
                            }
                            onClick={() => {
                                if (level?.id === 1) setIsModalOpen(true);
                                else if (level?.id === 2) setIsProfessionalModalOpen(true);
                            }}
                            className="lg:h-10 max-lg:h-8"
                            type="primary"
                        >
                            احراز هویت
                        </Button>
                    </Tooltip>
                </div>
            </Card>
        </>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    isAuth: state.authStatus,
    user: state.userData,
});

const connector = connect(mapStateToProps);
export default connector(ProfileVerify);
